import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Pagination } from '../../ofbiz-form-model';
import { PaginationService } from './pagination.service';
import { take } from 'rxjs/operators';


@Component({
  selector: 'ubs-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  pagination:Pagination;
  listSize:number;
  viewSizeOptions = [
    {value:10,key:"10 per page"},
    {value:20,key:"20 per page"},
    {value:30,key:"30 per page"},
    {value:40,key:"40 per page"},
    {value:50,key:"50 per page"}
  ];
  selectedViewSize = {value:20,key:"20 per page"};

  @Output() showFilter:EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private paginationService:PaginationService) { 
    this.paginationService.getPagination().pipe().subscribe((data:Pagination) => {
      this.pagination = data;
      console.log({Pagination:data});
    })
  }

  ngOnInit(): void {

  }
  setViewSize(newViewSize){
    this.paginationService.onViewSize(newViewSize);
  }

  first(e){
    this.paginationService.onFirst();
  }

  previous(e){
    this.paginationService.onPrevious();
  }

  next(e){
    this.paginationService.onNext();
  }

  last(e){
    this.paginationService.onLast()
  }

  useFilter(e){
    this.showFilter.emit(true)
  }

}
